import { schemaRequest } from "../../actions/schemaActions";
import { doRedirectCreate } from "../../actions/thunks/schemaThunks";
import { getAccessToken } from "../storage/accessTokenStorage";

const redirectCreate = (
  component,
  payload = null,
  message = null,
  submitEndpoint = null,
  redirectUrl = null
) => {
  component.props.dispatch(schemaRequest(component.props.id));
  const data = payload || component.props.data;
  const successMessage = message || "Created Successfully!";
  const endpoint = submitEndpoint || component.props.submitEndpoint;
  const url = redirectUrl || component.props.createRedirectUrl;
  const accessToken = component.props.accessToken || getAccessToken();
  component.props.dispatch(
    doRedirectCreate({
      accessToken,
      endpoint,
      successRedirectUrl: url,
      payload: data,
      navigate: component.props.navigate,
      message: successMessage,
    })
  );
};

export default redirectCreate;
